<template>
  <swiper
    ref="swiperRef"
    :effect="'coverflow'"
    :grabCursor="true"
    :centeredSlides="true"
    :slidesPerView="'auto'"
    :coverflowEffect="{
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    }"
    :pagination="{
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class='${className}'><img src='https://radgroups.ir/${props.images[index]}' /></span>`;
      },
    }"
    :modules="modules"
    class="mySwiper"
  >
    <swiper-slide
      v-for="(item, index) in props.images"
      :key="index"
      @click="showImage('https://radgroups.ir/' + item)"
    >
      <img :src="'https://radgroups.ir/' + item" />
    </swiper-slide>
    <div class="swiper-pagination"></div>
  </swiper>
  <ImageViewer ref="viewer" />
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { EffectCoverflow, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import { defineProps, ref, watch, onMounted, nextTick } from "vue";
import ImageViewer from "./lightbox.vue"; // مسیرت رو تنظیم کن
const viewer = ref(null);

function showImage(url) {
  viewer.value.open(url);
}
const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
});

const modules = [EffectCoverflow, Pagination];
const swiperRef = ref(null);

watch(
  () => props.images,
  async (newImages) => {
    if (newImages.length) {
      await nextTick(); // صبر کن DOM آپدیت بشه
      if (swiperRef.value && swiperRef.value.swiper) {
        swiperRef.value.swiper.update(); // به swiper بگو که خودش رو آپدیت کنه
      }
    }
  },
  { immediate: true }
);
</script>
<style>
.swiper-pagination {
  position: relative;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.swiper-pagination span {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.4;
  transition: all 0.3s ease;
  border-radius: 100%;
  opacity: 1;
}

.swiper-pagination span.swiper-pagination-bullet-active {
  opacity: 0.7;
  border: 1px solid rgb(91, 78, 78);
}

.swiper-pagination span img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.skeleton {
  background-color: #e2e5e7;
  border-radius: 0.5em;
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0)
  );
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: left -40px top 0;
  -webkit-animation: shine 1s ease infinite;
  animation: shine 1s ease infinite;
}

@-webkit-keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}

@keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}
</style>
